
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/curatedbyus",
      function () {
        return require("private-next-pages/explore/curatedbyus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/curatedbyus"])
      });
    }
  